<template>
  <div id="app" class="indexpage">
    <article class="mainContent">
      <HamburgerMenu
        :item="{
          homeUrl: homeUrl,
          cateUrl: cateUrl
        }"
      ></HamburgerMenu>
      <div id="fsvs-body" v-if="getDeviceType === 'SP'">
        <div class="slide" id="top">
          <div style="position: relative">
            <!-- headerBar -->
            <HeaderBox
              :item="{
                homeUrl: '../',
                cateUrl: cateUrl
              }"
            >
            </HeaderBox>
          </div>
          <!-- header -->
          <CategoryHeader
            :item="{
              categoryName: categoryName,
              categoryIntro: categoryIntro
            }"
          ></CategoryHeader>
        </div>
        <div
          class="slide position-relative"
          :id="list[4]"
          v-for="list in sortedCategoryListByRank"
          v-bind:key="list[4]"
        >
          <CategorySlideSp
            :item="{
              no: list[0],
              categoryId: list[1],
              categoryName: list[2],
              rank: list[3],
              magazineId: list[4],
              customMagazineDescription: list[5],
              authorComment: list[6],
              userComment: list[7],
              magazineTitle: list[8],
              coverImage: list[9],
              cycleType: list[10],
              magazineIdView: list[11],
              magazineDescription: list[12],
              free: list[13],
              firstMonthPayFlag: list[14],
              basicPriceWithTax: list[15]
            }"
          >
          </CategorySlideSp>
        </div>
        <div id="footer" class="slide scrollable" style="overflow-y: scroll">
          <!-- カテゴリーボタン枠 -->
          <CategorySpBackButton></CategorySpBackButton>
          <CategoryButtons
            :item="{
              cateUrl: cateUrl
            }"
          ></CategoryButtons>

          <!-- 歴代まぐまぐ大賞 -->
          <OldMag2Year></OldMag2Year>

          <!-- footer -->
          <IncFooter
            :item="{
              copyYear: copyYear
            }"
          ></IncFooter>
        </div>
      </div>

      <div v-if="getDeviceType === 'PC'">
        <!-- headerBar -->
        <HeaderBox
          :item="{
            homeUrl: homeUrl,
            cateUrl: cateUrl
          }"
        >
        </HeaderBox>
        <!-- header -->
        <CategoryHeader
          :item="{
            categoryName: categoryName,
            categoryIntro: categoryIntro
          }"
        ></CategoryHeader>
        <!-- category panels -->
        <section class="cateSection">
          <div class="" style="padding: 0">
            <div
              class="item_rank_wap_cate"
              v-for="list in sortedCategoryListByRank"
              v-bind:key="list[4]"
            >
              <CategoryPanel
                :item="{
                  no: list[0],
                  categoryId: list[1],
                  categoryName: list[2],
                  rank: list[3],
                  magazineId: list[4],
                  customMagazineDescription: list[5],
                  authorComment: list[6],
                  userComment: list[7],
                  magazineTitle: list[8],
                  coverImage: list[9],
                  cycleType: list[10],
                  magazineIdView: list[11],
                  magazineDescription: list[12],
                  free: list[13],
                  firstMonthPayFlag: list[14],
                  basicPriceWithTax: list[15]
                }"
              >
              </CategoryPanel>
            </div>
          </div>
        </section>

        <!-- カテゴリーボタン枠 -->
        <CategoryButtons
          :item="{
            cateUrl: cateUrl
          }"
        ></CategoryButtons>

        <!-- 歴代まぐまぐ大賞 -->
        <OldMag2Year></OldMag2Year>

        <!-- footer -->
        <IncFooter
          :item="{
            copyYear: copyYear
          }"
        ></IncFooter>
      </div>
      <!-- <my-footer></my-footer> -->
    </article>
  </div>
</template>

<script>
/* eslint-disable vue/no-side-effects-in-computed-properties */
import axios from 'axios'
import CategoryPanel from '@/components/CategoryPanel.vue'
import CategorySlideSp from '@/components/CategorySlideSP.vue'
import CategorySpBackButton from '@/components/CategorySpBackButton.vue'
import CategoryHeader from '@/components/CategoryHeader.vue'
import HamburgerMenu from '@/components/HamburgerMenu.vue'
import HeaderBox from '@/components/HeaderBox.vue'
import IncFooter from '@/components/IncFooter.vue'
import OldMag2Year from '@/components/OldMag2Year.vue'
import CategoryButtons from '@/components/CategoryButtons.vue'

export default {
  components: {
    CategoryPanel,
    CategorySlideSp,
    CategorySpBackButton,
    CategoryHeader,
    HamburgerMenu,
    HeaderBox,
    IncFooter,
    OldMag2Year,
    CategoryButtons
  },
  props: {
    cateName: {
      type: String,
      required: true
    },
    categoryName: {
      type: String,
      required: true
    },
    categoryIntro: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      cateUrl: '',
      homeUrl: '../',
      categoryList: [],
      isMounted: false,
      isDataLoaded: false
    }
  },
  computed: {
    sortedCategoryListByRank() {
      return this.categoryList.sort((a, b) => {
        // console.log(this.categoryList);
        return a[3] < b[3] ? -1 : a[3] > b[3] ? 1 : 0
      })
    },
    copyYear() {
      return new Date().getFullYear()
    },
    getDeviceType() {
      var width = window.innerWidth
      if (width > 500) {
        return 'PC'
      } else {
        return 'SP'
      }
    }
  },
  mounted() {
    var self = this

    const $ = window.$
    if (window.innerWidth > 500) {
      $('html').removeClass('fsvs')
    }

    self.getAwardData()

    this.$nextTick(() => {
      this.loading = false
      //this.moveScroll();
    })
  },
  updated() {
    //initialize slider
    const $ = window.$
    if (this.isDataLoaded) {
      $.fn.fsvs({
        autoPlay: false,
        speed: 500,
        bodyID: 'fsvs-body',
        selector: '> .slide',
        mouseSwipeDisance: 40,
        afterSlide: function() {},
        beforeSlide: function() {},
        endSlide: function() {},
        mouseWheelEvents: true,
        mouseWheelDelay: false,
        mouseDragEvents: false,
        touchEvents: true,
        arrowKeyEvents: true,
        pagination: true,
        nthClasses: 2,
        detectHash: true
      })
    }

    // scroll to anchor link
    var hash = $(location).attr('hash')
    if ($(hash).length) {
      $('html, body').animate({
        scrollTop: $(hash).offset().top
      })
    }
  },
  methods: {
    moveScroll: function() {
      var element = document.getElementById('topWideColContentBox')
      element.scrollLeft = 10000
    },
    getAwardData: function() {
      var self = this
      axios.get('../assets/data/data2.json').then(function(response) {
        response.data.filter(function(item) {
          let magazineInfos = []
          magazineInfos.push(item.no)
          magazineInfos.push(item.categoryId)
          magazineInfos.push(item.categoryName)
          magazineInfos.push(item.rank)
          magazineInfos.push(item.magazineId)
          magazineInfos.push(item.customMagazineDescription)
          magazineInfos.push(item.authorComment)
          magazineInfos.push(item.userComment)
          magazineInfos.push(item.magazineTitle)
          magazineInfos.push(item.coverImage)
          magazineInfos.push(item.cycleType)
          magazineInfos.push(item.magazineIdView)
          magazineInfos.push(item.magazineDescription)
          magazineInfos.push(item.free)
          magazineInfos.push(item.firstMonthPayFlag)
          magazineInfos.push(item.basicPriceWithTax)
          if (item.categoryId == self.cateName) {
            self.categoryList.push(magazineInfos)
          }
        })
        self.isDataLoaded = true
      })
    }
  }
}
</script>

<style scoped>
/* category page */
.item_rank_wap_cate {
  width: 100%;
  max-width: 1200px;
  margin: 0 auto 30px;
  position: relative;
  background: #fff;
}
.cateSection {
  margin: 50px 0 0;
}
</style>
